// import { faPlus } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Delete } from "@mui/icons-material";
// import axios from "axios";
// import { useEffect, useState } from "react";
// import { Button } from "react-bootstrap";
// import { toast, ToastContainer } from "react-toastify";

// const Skills = ({ userId }) => {
//   const BASE_API_URL = process.env.REACT_APP_API_URL;
//   const [skills, setSkills] = useState([]);
//   const [newSkill, setNewSkill] = useState("");
//   const [showSkillsMessage, setShowSkillsMessage] = useState(false);
//   const [loading, setLoading] = useState(false);

//   // Fetch only skills when this component mounts
//   useEffect(() => {
//     const fetchSkills = async () => {
//       try {
//         const response = await axios.get(
//           `${BASE_API_URL}/getCandidate?userId=${userId}`
//         );
//         const skillsArray = response.data.skills
//           ? response.data.skills.split(",").map((skill) => skill.trim())
//           : [];
//         setSkills(skillsArray);
//       } catch (error) {
//         console.error("Error fetching skills:", error);
//       }
//     };

//     if (userId) {
//       fetchSkills();
//     }
//   }, [userId, BASE_API_URL]);

//   const handleAddSkill = () => {
//     if (newSkill && !skills.includes(newSkill)) {
//       setSkills([...skills, newSkill]);
//       setNewSkill("");
//       setShowSkillsMessage(false);
//     }
//   };

//   const handleRemoveSkill = (index) => {
//     setSkills(skills.filter((_, i) => i !== index));
//   };

//   const handleSaveSkills = async () => {
//     if (skills.length < 5) {
//       setShowSkillsMessage(true);
//       return;
//     }

//     setLoading(true);
//     try {
//       // Convert skills array to a comma-separated string
//       const skillsString = skills.join(", ");

//       // Prepare payload - We send only skills here.
//       // Ensure your backend supports partial updates or fetch existing Education data if strict replacement is needed.
//       const updatedFormData = {
//         skills: skillsString,
//       };

//       await axios.put(
//         `${BASE_API_URL}/updateCandidateDetails`,
//         updatedFormData,
//         {
//           params: { userId },
//         }
//       );

//       toast.success("Skills updated successfully!");
//     } catch (error) {
//       console.error("Error updating skills:", error);
//       toast.error("Error updating skills");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <h4>Skills:</h4>
//       <p className="text-danger mb-3">(Note: Add at least 5 skills)</p>

//       {/* Skills List */}
//       <div className="mb-3 d-flex flex-wrap">
//         {skills.map((skill, index) => (
//           <span
//             key={index}
//             className="badge text-dark me-2 mb-2 position-relative d-inline-flex align-items-center"
//             style={{
//               fontSize: "1rem",
//               padding: "0.5rem 1rem",
//               borderRadius: "0.25rem",
//               border: "1px solid grey",
//             }}
//           >
//             {skill}
//             <i
//               className="text-danger ms-2"
//               onClick={() => handleRemoveSkill(index)}
//               style={{ cursor: "pointer", fontSize: "1.2rem" }}
//             >
//               <Delete fontSize="small" />
//             </i>
//           </span>
//         ))}
//       </div>

//       {/* Add New Skill Input */}
//       <div className="d-flex align-items-center mb-4">
//         <input
//           type="text"
//           value={newSkill}
//           onChange={(e) => {
//             setNewSkill(e.target.value);
//             setShowSkillsMessage(false);
//           }}
//           placeholder="Add a new skill"
//           className="form-control me-2"
//           style={{ width: "300px" }}
//           onKeyDown={(e) => e.key === "Enter" && handleAddSkill()}
//         />
//         <Button variant="primary" onClick={handleAddSkill}>
//           <FontAwesomeIcon icon={faPlus} />
//         </Button>
//       </div>

//       {showSkillsMessage && (
//         <p className="text-danger mt-3">Please add at least 5 skills.</p>
//       )}

//       {/* Save Button specifically for Skills */}
//       <div className="d-flex justify-content-center mt-3">
//         <Button variant="primary" onClick={handleSaveSkills} disabled={loading}>
//           {loading ? "Saving..." : "Save Skills"}
//         </Button>
//       </div>
//       <ToastContainer
//         position="top-right"
//         autoClose={5000}
//         hideProgressBar={false}
//       />
//     </>
//   );
// };

// export default Skills;

import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Delete } from "@mui/icons-material";
import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import { SKILLS_LIST } from "./skillsList";

const Skills = ({ userId }) => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const [skills, setSkills] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch existing skills on mount
  useEffect(() => {
    const fetchUserSkills = async () => {
      try {
        const res = await axios.get(
          `${BASE_API_URL}/getCandidate?userId=${userId}`
        );
        const skillsArray = res.data.skills
          ? res.data.skills.split(",").map((s) => s.trim())
          : [];
        setSkills(skillsArray);
      } catch (err) {
        console.error("Error fetching skills:", err);
      }
    };
    if (userId) fetchUserSkills();
  }, [userId, BASE_API_URL]);

  // Filter suggestions based on input
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value.length > 0) {
      const filtered = SKILLS_LIST.filter(
        (skill) =>
          skill.toLowerCase().includes(value.toLowerCase()) &&
          !skills.includes(skill)
      ).slice(0, 10);
      setSuggestions(filtered);
    } else {
      setSuggestions([]);
    }
  };

  const addSkill = (skillName) => {
    if (!skillName) return;
    if (!skills.includes(skillName)) {
      setSkills([...skills, skillName]);
    }
    setInputValue("");
    setSuggestions([]);
  };

  const removeSkill = (index) => {
    const removed = skills[index];
    setSkills(skills.filter((_, i) => i !== index));
    toast.info(`Removed skill: ${removed}`);
  };

  const handleSave = async () => {
    if (skills.length < 5) {
      toast.warning("Please add at least 5 skills");
      return;
    }
    setLoading(true);
    try {
      await axios.put(
        `${BASE_API_URL}/updateCandidateDetails`,
        { skills: skills.join(", ") },
        { params: { userId } }
      );
      toast.success("Skills saved successfully!");
    } catch (err) {
      console.error(err);
      toast.error("Failed to save skills");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h5 className="mb-3 text-secondary">Technical Skills</h5>
      <p>
        <strong>Note:</strong> Add your skills here. When you apply for jobs, HR
        can view your profile details and reach out to you directly.
      </p>

      {/* Input with suggestions */}
      <div className="position-relative" style={{ maxWidth: "400px" }}>
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder="Type a skill or add custom"
            value={inputValue}
            onChange={handleInputChange}
            onKeyDown={(e) => e.key === "Enter" && addSkill(inputValue)}
          />
          <Button variant="primary" onClick={() => addSkill(inputValue)}>
            <FontAwesomeIcon icon={faPlus} />
          </Button>
        </div>

        {/* Suggestions dropdown */}
        {suggestions.length > 0 && (
          <ul className="list-group position-absolute w-100 z-3 shadow mt-1">
            {suggestions.map((s, i) => (
              <li
                key={i}
                className="list-group-item list-group-item-action"
                style={{ cursor: "pointer" }}
                onClick={() => addSkill(s)}
              >
                {s}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Selected skills */}
      <div className="d-flex flex-wrap gap-2 my-3">
        {skills.map((s, i) => (
          <div
            key={i}
            className="badge bg-secondary d-flex align-items-center p-2 rounded-pill"
          >
            {s}{" "}
            <Delete
              className="ms-2"
              style={{ fontSize: "1rem", cursor: "pointer" }}
              onClick={() => removeSkill(i)}
            />
          </div>
        ))}
      </div>

      {/* Save Button */}
      <div className="mt-4 text-center">
        <Button
          variant="success"
          onClick={handleSave}
          disabled={loading}
          className="px-4"
        >
          {loading ? <Spinner size="sm" /> : "Save"}
        </Button>
      </div>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default Skills;
